import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-diagnostic-tool',
    templateUrl: './diagnostic-tool.component.html',
    styleUrls: ['./diagnostic-tool.component.sass'],
    standalone: false
})

export class DiagnosticToolComponent {
  
  @Input() number: string = "";
  @Input() text: string = "";
  @Input() subtext: string = "";
  @Input() isLink: boolean = false;
  @Input() link: string = "";
  
}